import getLocal from 'eco-design-reliance/getLocal';
import EcoImg from 'eco-design/base/eco-img';
import { i18n } from '../../i18n';
import './index.scss';

const EcoCartEmpty: React.FC = () => {
    const { locale = '' } = getLocal();
    const t = i18n?.[locale] || i18n.en;

    return (
        <div className="eco-cart-no-data">
            <p className="no-data-text">{t.cart_empty}</p>
            <EcoImg className="no-data-img" pc="https://websiteoss.ecoflow.com/upload/image/1751249391916/empty.png" alt={t.cart_empty} />
        </div>
    );
};

export default EcoCartEmpty;
